<template>
    <span>
        <h4>Anexos</h4>
        <span v-if='attachments.length' v-for="attachment in attachments" style="margin-right: 5px; margin-top: 25px;">

            <a :href="attachment.link" @click.prevent="openAttachment(attachment)" class="tooltip">

                <svg v-if='attachment.extension == "pdf"' xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="50px" width="50px" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
                    <path style="fill:#E2E5E7;" d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"/>
                    <path style="fill:#B0B7BD;" d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"/>
                    <polygon style="fill:#CAD1D8;" points="480,224 384,128 480,128 "/>
                    <path style="fill:#F15642;" d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16  V416z"/>
                    <g>
                        <path style="fill:#FFFFFF;" d="M101.744,303.152c0-4.224,3.328-8.832,8.688-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48   c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.688-3.184-8.688-8.816V303.152z    M118.624,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H118.624z"/>
                        <path style="fill:#FFFFFF;" d="M196.656,384c-4.224,0-8.832-2.304-8.832-7.92v-72.672c0-4.592,4.608-7.936,8.832-7.936h29.296   c58.464,0,57.184,88.528,1.152,88.528H196.656z M204.72,311.088V368.4h21.232c34.544,0,36.08-57.312,0-57.312H204.72z"/>
                        <path style="fill:#FFFFFF;" d="M303.872,312.112v20.336h32.624c4.608,0,9.216,4.608,9.216,9.072c0,4.224-4.608,7.68-9.216,7.68   h-32.624v26.864c0,4.48-3.184,7.92-7.664,7.92c-5.632,0-9.072-3.44-9.072-7.92v-72.672c0-4.592,3.456-7.936,9.072-7.936h44.912   c5.632,0,8.96,3.344,8.96,7.936c0,4.096-3.328,8.704-8.96,8.704h-37.248V312.112z"/>
                    </g>
                    <path style="fill:#CAD1D8;" d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"/>
                </svg>
                
                <svg v-else-if='attachment.extension == "txt"' xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="50px" width="50px" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
                    <path style="fill:#E2E5E7;" d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"/>
                    <path style="fill:#B0B7BD;" d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"/>
                    <polygon style="fill:#CAD1D8;" points="480,224 384,128 480,128 "/>
                    <path style="fill:#576D7E;" d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16  V416z"/>
                    <g>
                        <path style="fill:#FFFFFF;" d="M132.784,311.472H110.4c-11.136,0-11.136-16.368,0-16.368h60.512c11.392,0,11.392,16.368,0,16.368   h-21.248v64.592c0,11.12-16.896,11.392-16.896,0v-64.592H132.784z"/>
                        <path style="fill:#FFFFFF;" d="M224.416,326.176l22.272-27.888c6.656-8.688,19.568,2.432,12.288,10.752   c-7.68,9.088-15.728,18.944-23.424,29.024l26.112,32.496c7.024,9.6-7.04,18.816-13.952,9.344l-23.536-30.192l-23.152,30.832   c-6.528,9.328-20.992-1.152-13.68-9.856l25.696-32.624c-8.048-10.096-15.856-19.936-23.664-29.024   c-8.064-9.6,6.912-19.44,12.784-10.48L224.416,326.176z"/>
                        <path style="fill:#FFFFFF;" d="M298.288,311.472H275.92c-11.136,0-11.136-16.368,0-16.368h60.496c11.392,0,11.392,16.368,0,16.368   h-21.232v64.592c0,11.12-16.896,11.392-16.896,0V311.472z"/>
                    </g>
                    <path style="fill:#CAD1D8;" d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"/>
                </svg>

                <svg v-else-if='attachment.extension == "doc" || attachment.extension == "docx" ' xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="50px" width="50px" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
                    <path style="fill:#E2E5E7;" d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"/>
                    <path style="fill:#B0B7BD;" d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"/>
                    <polygon style="fill:#CAD1D8;" points="480,224 384,128 480,128 "/>
                    <path style="fill:#50BEE8;" d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16  V416z"/>
                    <g>
                        <path style="fill:#FFFFFF;" d="M92.576,384c-4.224,0-8.832-2.32-8.832-7.936v-72.656c0-4.608,4.608-7.936,8.832-7.936h29.296   c58.464,0,57.168,88.528,1.136,88.528H92.576z M100.64,311.072v57.312h21.232c34.544,0,36.064-57.312,0-57.312H100.64z"/>
                        <path style="fill:#FFFFFF;" d="M228,385.28c-23.664,1.024-48.24-14.72-48.24-46.064c0-31.472,24.56-46.944,48.24-46.944   c22.384,1.136,45.792,16.624,45.792,46.944C273.792,369.552,250.384,385.28,228,385.28z M226.592,308.912   c-14.336,0-29.936,10.112-29.936,30.32c0,20.096,15.616,30.336,29.936,30.336c14.72,0,30.448-10.24,30.448-30.336   C257.04,319.008,241.312,308.912,226.592,308.912z"/>
                        <path style="fill:#FFFFFF;" d="M288.848,339.088c0-24.688,15.488-45.92,44.912-45.92c11.136,0,19.968,3.328,29.296,11.392   c3.456,3.184,3.84,8.816,0.384,12.4c-3.456,3.056-8.704,2.688-11.776-0.384c-5.232-5.504-10.608-7.024-17.904-7.024   c-19.696,0-29.152,13.952-29.152,29.552c0,15.872,9.328,30.448,29.152,30.448c7.296,0,14.08-2.96,19.968-8.192   c3.952-3.072,9.456-1.552,11.76,1.536c2.048,2.816,3.056,7.552-1.408,12.016c-8.96,8.336-19.696,10-30.336,10   C302.8,384.912,288.848,363.776,288.848,339.088z"/>
                    </g>
                    <path style="fill:#CAD1D8;" d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"/>
                </svg>

                <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="50px" width="50px" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
                    <path style="fill:#E2E5E7;" d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"/>
                    <path style="fill:#B0B7BD;" d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"/>
                    <polygon style="fill:#CAD1D8;" points="480,224 384,128 480,128 "/>
                    <path style="fill:#576D7E;" d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16  V416z"/>
                    <g>
                        <path style="fill:#FFFFFF;" d="M94.912,375.68c0,11.12-17.024,11.504-17.024,0.256V303.28c0-4.48,3.472-7.808,7.68-7.808H119.6   c32.48,0,39.136,43.504,12.016,54.368l17.008,20.72c6.656,9.856-6.64,19.312-14.336,9.6l-19.312-27.632H94.912V375.68z    M94.912,337.808H119.6c16.624,0,17.664-26.864,0-26.864H94.912V337.808z"/>
                        <path style="fill:#FFFFFF;" d="M162.624,384c-4.096-2.32-6.656-6.912-4.096-12.288l36.704-71.76c3.456-6.784,12.672-7.04,15.872,0   l36.064,71.76c5.248,9.968-10.24,17.904-14.832,7.936l-5.648-11.264h-47.2l-5.504,11.264C171.952,384,167.216,384.912,162.624,384z    M217.632,351.504l-14.448-31.6l-15.728,31.6H217.632z"/>
                        <path style="fill:#FFFFFF;" d="M341.248,353.424l19.056-52.704c3.84-10.352,19.312-5.504,15.488,5.632l-25.328,68.704   c-2.32,7.296-4.48,9.472-8.832,9.472c-4.608,0-6.016-2.832-8.576-7.424L310.8,326.576l-21.248,49.76   c-2.304,5.36-4.464,8.432-9.072,8.432c-4.464,0-6.784-3.072-8.832-8.704l-24.816-69.712c-3.84-11.504,12.4-15.728,15.728-5.632   l18.944,52.704l22.64-52.704c3.056-7.808,11.12-8.192,14.448-0.368L341.248,353.424z"/>
                    </g>
                    <path style="fill:#CAD1D8;" d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"/>
                </svg> 

                <span class="tooltiptext">{{ attachment.filename }}</span> 
                
            </a> 
            
            <svg v-if='show_options' v-on:click='deleteAttachment(attachment)' xmlns="http://www.w3.org/2000/svg" height="20px" width="20px" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="delete-icon w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
            </svg> 
            
        </span>
        <span v-if='!attachments.length'>
            Nenhum anexo vinculado a esta demanda
            <br>
        </span>
    </span> 
</template>

<script>
    export default {
        props:{
            attachments: {
                type: Array,
                required: true,
            },
            is_bid: true,
            show_options: false,
            id: '',
            path: ''
        },
        methods: {

            openAttachment (attachment) {
                window.open(attachment.link);
            },

            downloadAttachment (attachment) {
                axios.get(attachment.link, { responseType: 'blob' })
                    .then(response => {

                        const blob = new Blob([response.data], { type: 'application/pdf' })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = attachment.filename
                        link.click()
                        URL.revokeObjectURL(link.href)
                    
                    }).catch(console.error)
            },
            deleteAttachment(data){
                
                if (this.show_options && confirm("Deseja deletar o arquivo: "+data.filename+"? Essa ação é permanente!") == true) {
                
                    axios.post('/demandas/delete_attachment', {
                        id: this.id,
                        attachment_name: data.filename,
                        attachment_path: this.path,
                        is_bid: this.is_bid
                    }).then((response) =>  {

                            this.attachments = response.data;

                            toastr.success('Anexo deletado com sucesso');
                        })
                        .catch((err) => {
                            toastr.error('Erro ao deletar anexo');
                        });
                    
                }

            },
        }
    }
</script>

<style>

    .delete-icon {
        color: red;
    }   

    .delete-icon:hover {
        cursor: pointer;
        color: rgb(158, 36, 36);
    }   

    .tooltip {
        position: relative;
        display: inline-block; 
        opacity: 1;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        width: 120px;
        background-color: #555;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        margin-left: -60px;
        opacity: 0;
        transition: opacity 0.3s;
    }

    .tooltip .tooltiptext::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #555 transparent transparent transparent;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
    }

</style>